import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    IEditProviderInfo,
    IOverrideProviderSupervisorPayload,
    IPauseClientPayload,
    IProviderCaseloadFilters,
    IProvidersFilterTypes,
    IProviderUpcomingSessionsFilters,
    ISuperviseeCaseloadFilters,
} from "../types/providers.types";

// Endpoint to fetch provider's caseload
export async function fetchProviderCaseload(params: IProviderCaseloadFilters) {
    const response = await axios.get(`/${params.providerId}/caseload`, {
        params: handleRemoveEmptyParamFromQueryParams(params),
    });

    return response.data;
}

// Endpoint to fetch Supervisees caseload
export async function fetchSuperviseesCaseload(
    filters: ISuperviseeCaseloadFilters
) {
    const response = await axios.get(
        `/provider/${filters.providerId}/supervisee`,
        {
            params: handleRemoveEmptyParamFromQueryParams(filters),
        }
    );
    return response.data;
}

export async function fetchProviders(filters: IProvidersFilterTypes) {
    const response = await axios.get(`/providers`, {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });
    return response.data;
}

export async function updateProviderInfo(
    providerId: string,
    data: IEditProviderInfo
) {
    const response = await axios.patch(`/providers/${providerId}`, data);
    return response.data;
}

export async function pauseProviderClient(data: IPauseClientPayload) {
    const response = await axios.post(`/provider/pause-clients`, data);
    return response.data;
}

export async function fetchActiveProviders(providerName?: string) {
    const response = await axios.get(`/active-providers`, {
        params: { provider_name: providerName },
    });
    return response.data;
}

export async function fetchProviderUpcomingSessions(
    providerId: string,
    filters: IProviderUpcomingSessionsFilters
) {
    const response = await axios.get(
        `/provider/${providerId}/upcoming-sessions`,
        {
            params: filters,
        }
    );
    return response.data;
}

export async function overrideProvidersSupervisor(
    providerId: string,
    payload: IOverrideProviderSupervisorPayload
) {
    const response = await axios.put(
        `/providers/${providerId}/override-supervisor`,
        payload
    );
    return response.data;
}
